import {
  MAIN_CITIES_AC,
  MAIN_CITIES_AL,
  MAIN_CITIES_AP,
  MAIN_CITIES_AM,
  MAIN_CITIES_BA,
  MAIN_CITIES_CE,
  MAIN_CITIES_DF,
  MAIN_CITIES_ES,
  MAIN_CITIES_GO,
  MAIN_CITIES_MA,
  MAIN_CITIES_MT,
  MAIN_CITIES_MS,
  MAIN_CITIES_MG,
  MAIN_CITIES_PA,
  MAIN_CITIES_PB,
  MAIN_CITIES_PR,
  MAIN_CITIES_PE,
  MAIN_CITIES_PI,
  MAIN_CITIES_RJ,
  MAIN_CITIES_RN,
  MAIN_CITIES_RS,
  MAIN_CITIES_RO,
  MAIN_CITIES_RR,
  MAIN_CITIES_SC,
  MAIN_CITIES_SP,
  MAIN_CITIES_SE,
  MAIN_CITIES_TO,
} from './main-cities-by-state.const';

import { City } from '@/types/city.type';

export const mainCities: City[] = [
  { city: 'Curitiba', state_abbr: 'PR', slug: 'curitiba-pr' },
  { city: 'Belo Horizonte', state_abbr: 'MG', slug: 'belo-horizonte-mg' },
  { city: 'Florianópolis', state_abbr: 'SC', slug: 'florianopolis-sc' },
  { city: 'Goiânia', state_abbr: 'GO', slug: 'goiania-go' },
  { city: 'Teresina', state_abbr: 'PI', slug: 'teresina-pi' },
];

export const mainCitiesByState: Record<string, City[]> = {
  AC: MAIN_CITIES_AC,
  AL: MAIN_CITIES_AL,
  AP: MAIN_CITIES_AP,
  AM: MAIN_CITIES_AM,
  BA: MAIN_CITIES_BA,
  CE: MAIN_CITIES_CE,
  DF: MAIN_CITIES_DF,
  ES: MAIN_CITIES_ES,
  GO: MAIN_CITIES_GO,
  MA: MAIN_CITIES_MA,
  MT: MAIN_CITIES_MT,
  MS: MAIN_CITIES_MS,
  MG: MAIN_CITIES_MG,
  PA: MAIN_CITIES_PA,
  PB: MAIN_CITIES_PB,
  PR: MAIN_CITIES_PR,
  PE: MAIN_CITIES_PE,
  PI: MAIN_CITIES_PI,
  RJ: MAIN_CITIES_RJ,
  RN: MAIN_CITIES_RN,
  RS: MAIN_CITIES_RS,
  RO: MAIN_CITIES_RO,
  RR: MAIN_CITIES_RR,
  SC: MAIN_CITIES_SC,
  SP: MAIN_CITIES_SP,
  SE: MAIN_CITIES_SE,
  TO: MAIN_CITIES_TO,
};

export const STATE_ABBR_TO_NAME: Record<string, string> = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
};
